// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__VG-hX","spin":"styles_spin__1Dsfe","error":"styles_error__1YjlL","success":"styles_success__3lPbX"};